namespace TabAurous.OMS {
    export namespace LedgerPostingService {
        export const baseUrl = 'OMS/LedgerPosting';

        export declare function Create(request: Serenity.SaveRequest<LedgerPostingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<LedgerPostingRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BalanceSheetList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProfitandLossList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/LedgerPosting/Create",
            Update = "OMS/LedgerPosting/Update",
            Delete = "OMS/LedgerPosting/Delete",
            Retrieve = "OMS/LedgerPosting/Retrieve",
            List = "OMS/LedgerPosting/List",
            CustomList = "OMS/LedgerPosting/CustomList",
            BalanceSheetList = "OMS/LedgerPosting/BalanceSheetList",
            ProfitandLossList = "OMS/LedgerPosting/ProfitandLossList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList', 
            'BalanceSheetList', 
            'ProfitandLossList'
        ].forEach(x => {
            (<any>LedgerPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
